/* eslint-disable no-param-reassign */
import cloneDeep from 'lodash/cloneDeep';
import defaults from '@/store/hoPaginatedList/state';
import mutations from '@/store/hoPaginatedList/mutations';

export default {
  ...mutations,
  beginRequest(state, channel) {
    if (state.channel !== channel) Object.assign(state, cloneDeep(defaults));
    state.channel = channel;
    state.requestId += 1;
    state.isLoading = true;
  },
};
